"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var fclasses_1 = require("@bodiless/fclasses");

var lodash_1 = require("lodash");

var withChameleonContext_1 = require("./withChameleonContext");
/**
 * Applies the appropriate design to the wrapped component depending on the
 * chameleon state.  Must be called within a context defined by `withChameleonContext`.
 *
 * Use this function when you want to separate the form controlling the chameleon
 * state from the component on which the chameleon acts (for example, if you want
 * to add controls to a component edit form, but actually act on the component
 * to which the edit form was added), eg:
 *
 * ```
 * flowRight(
 *   withDesign({
 *     Disabled: flow(replaceWith('span'), withoutProps('href'), withTitle('Disabled'))
 *   }),
 *   withChameleonContext('link-chameleon'),
 *   withChameleonComponenFormConrols,
 *   asBodilessLink('link')
 *   applyChameleon,
 * )('a');
 * ```
 *
 * Note the use of `withTitle` here.  Only design elements with title metadata will be considered
 * valid chameleon states.
 *
 * @return The wrapped component enhanced by the appropriate HOC's from the design.
 */


var applyChameleon = function applyChameleon(Component) {
  var Chameleon = function Chameleon(props) {
    var activeComponent = withChameleonContext_1.useChameleonContext().activeComponent;

    var components = props.components,
        rest = __rest(props, ["components"]);

    var ActiveComponent = components[activeComponent];
    return react_1.default.createElement(ActiveComponent, __assign({}, rest));
  };

  return lodash_1.flow(fclasses_1.withoutProps('design'), withChameleonContext_1.applyChameleonDesign(Component))(Chameleon);
};

exports.default = applyChameleon;